// extracted by mini-css-extract-plugin
export default {"container":"Notifications_container__g7uok"};